import { RcsbFvCoreBuilder } from "../RcsbFvWeb/RcsbFvBuilder/RcsbFvCoreBuilder";
export class RcsbFvUI {
    static clearSelectButton(elementFvId, selectButtonId) {
        RcsbFvCoreBuilder.clearAdditionalSelectButton(elementFvId, selectButtonId);
    }
    static createSelectButton(elementFvId, selectButtonId, options, config) {
        RcsbFvCoreBuilder.buildSelectButton(elementFvId, selectButtonId, options, config);
    }
    static addSelectButton(elementFvId, selectButtonId, options, config) {
        RcsbFvCoreBuilder.addSelectButton(elementFvId, selectButtonId, options, config);
    }
}
//# sourceMappingURL=RcsbFvUI.js.map